import { AUTH_TYPES } from '@/store/auth'

export default function ({ store, redirect, route }) {
  if (!store.getters[AUTH_TYPES.getters.isAuthenticated]) {
    redirect(`/auth/callback?redirect=${encodeURIComponent(route.fullPath)}`)
  }
}
